<template>
  <ul v-if="messageArticleList" class="p-j-message-article-list">
    <li
      v-for="(messageDetail, key) in messageArticleList"
      class="p-j-message-article-list__item"
      :key="key"
    >
      <JMessageArticlePanel
        :message-article-detail="messageDetail"
        :exclude="exclude"
      />
    </li>
  </ul>
</template>

<script lang="ts">
import JMessageArticlePanel from "@/general/components/pages/parts/ThanksPointList/JMessageArticlePanel.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    messageArticleList: { type: Array, required: true },
    exclude: { type: Array, default: () => ([]) }
  },
  components: {
    JMessageArticlePanel
  }
})
export default class JMessageArticleList extends Vue {
  messageArticleList!: any;
  exclude!: any;
}
</script>

<style lang="scss" scoped>
.p-j-message-article-list {
  &__item {
    margin-bottom: rem(12);

    background: $common-white;
    border: 1px solid $common-gray300;
    border-radius: rem(8);

    box-shadow: 0 1px 3px rgba(0, 0, 0, .08);

    overflow: hidden;
  }
}
</style>
